import React, { useContext, useState, useEffect } from "react";
import AddEditProject from "./AddEditProject";
import DeleteModal from "../DeleteModal/DeleteModal";
import ProjectsGridView from "./ProjectsGridView/ProjectsGridView";
import DropdownComp from "../Dropdowns/DropdownComp";
import GeneralTable from "../GeneralTable";
import SearchBarComp from "../SearchBar/SearchBar";
import { checkSpecificPermission } from "../../utils/checkPermissions";
import { UserContext } from "../../context/UserContext";
import axios from "axios";
import { Error, Success } from "../Messages/Messages";
import { generalErrorAlert } from "../GeneralErrorAlert";
import Tagcomp from "../../commons/TagComp/Tagcomp";
import dayjs from "dayjs";
import PageToolbar from "../../design-system/PageToolbar";

import { useTranslation } from "react-i18next";
const ProjectLists = ({
  serviceProviderId,
  projectsArray,
  totalCount,
  updateParent,
  handleSearch,
  serviceProvider,
  handlePageChange,
  pageNo,
  pageSize,
  employeeObject
}) => {
  const { t } = useTranslation("dashboard");
  const [layout] = useState("list");
  const loggedInUserObject = useContext(UserContext);
  const [inventoryList, setInventoryList] = useState([]);

  useEffect(() => {
    getInventory();
  }, []);

  const deleteProjectHandler = async id => {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/projects/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      });
      if (res.status === 200 || res.status === 304) {
        Success(res.data.successMessage);
        updateParent();
      }
    } catch (err) {
      generalErrorAlert(err);
    }
  };

  const getInventory = async () => {
    try {
      await axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/inventory/filters`,
          {
            pageSize: 1000000,
            pageNo: 0
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            setInventoryList(res.data.data);
          } else {
            Error(res.data.errorMessage);
          }
        })
        .catch(err => {
          generalErrorAlert(err);
        });
    } catch (error) {
      generalErrorAlert(error);
    }
  };

  const columns = [
    {
      title: t("Name"),
      dataIndex: "projectName",
      mobile: "title",
      sorter: (a, b) => a.projectName.localeCompare(b.projectName)
    },
    // {
    //   title: t("Service Provider"),
    //   dataIndex: "service Provider",
    //   render: (text, record) => (
    //     <>
    //       <>
    //         <span style={{ color: "black", marginLeft: "20px" }}>
    //           {record?.serviceProvider?.firstName} {record?.serviceProvider?.lastName}
    //         </span>
    //       </>
    //     </>
    //   ),
    //   sorter: (a, b) => a?.serviceProvider?.firstName.localeCompare(b?.serviceProvider?.firstName)
    // },
    {
      title: t("Start Date"),
      dataIndex: "startDate",
      render: text => dayjs(text).format("DD/MMM/YYYY")
    },
    {
      title: t("End Date"),
      dataIndex: "endDate",
      render: text => dayjs(text).format("DD/MMM/YYYY")
    },
    {
      title: t("Priority"),
      dataIndex: "priority",
      sorter: (a, b) => a.priority.localeCompare(b?.localeCompare),
      render: (text, record) => <Tagcomp text={record.priority} />
    },
    {
      title: t("Status"),
      dataIndex: "status",
      mobile: "subtitle",
      sorter: (a, b) => a.status.localeCompare(b?.status),
      render: (text, record) => <Tagcomp text={record.status} />
    },
    {
      title: t("Action"),
      key: "action",
      render: (text, obj) => {
        const menuItems = [
          {
            key: "view",
            link: `/user/projects/${obj?._id}`
          },
          {
            key: "edit",
            component: () => (
              <AddEditProject
                inventoryList={inventoryList}
                serviceProviderId={serviceProviderId}
                data={obj}
                updateParent={updateParent}
                employeeObject={employeeObject}
              />
            )
          },
          {
            key: "delete",
            component: () => (
              <DeleteModal text="Project" onClick={() => deleteProjectHandler(obj?._id)} />
            )
          }
        ];
        return (
          serviceProvider && (
            <div>
              <DropdownComp menuItems={menuItems} />
            </div>
          )
        );
      }
    }
  ];

  return (
    <>
      <PageToolbar
        filters={<SearchBarComp handleSearch={handleSearch} />}
        actions={
          checkSpecificPermission(
            loggedInUserObject?.roleId?.permissions,
            "Projects",
            "Create"
          ) && (
            <AddEditProject
              inventoryList={inventoryList}
              serviceProviderId={serviceProviderId}
              updateParent={updateParent}
              employeeObject={employeeObject}
            />
          )
        }
      />
      {layout === "grid" ? (
        <ProjectsGridView projects={projectsArray} serviceProvider={serviceProvider} />
      ) : (
        <GeneralTable
          pageNo={pageNo}
          pageSize={pageSize}
          totalCount={totalCount}
          data={projectsArray}
          columns={columns}
          setPageNo={handlePageChange}
        />
      )}
    </>
  );
};

export default ProjectLists;
